// extracted by mini-css-extract-plugin
export default {"category":"Categories_category__pd3ZE","header":"Categories_header__9w1WB"};